import {
  GET_BILLING_DATA,
  GET_BILLING_DATA_SUCCESS,
  GET_BILLING_DATA_FAIL
} from '../constants/billing';

const initialState = {
  loading: false,
  loaded: false,
  data: null,
  error: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_BILLING_DATA:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: true,
          loaded: false,
          data: null,
          error: null
        }
      };
    case GET_BILLING_DATA_FAIL:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: false,
          loaded: false,
          data: null,
          error: action.error
        }
      };
    case GET_BILLING_DATA_SUCCESS:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: false,
          loaded: true,
          data: action.data,
          error: null
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/billing.js